<template>
  <base-layout pageTitle="RSS">
    <div v-if="rssItems.length">
      <div v-for="item in rssItems" :key="item.link">
        <h2>{{ item.title }}</h2>
        <p>{{ item.description }}</p>
        <a :href="item.link" target="_blank">Read more</a>
      </div>
    </div>
    <div v-else>
      Loading...
    </div>
  </base-layout>
</template>


<!--<template>-->
<!--  <ion-menu side="end" content-id="main-content">-->
<!--    <ion-header>-->
<!--      <ion-toolbar>-->
<!--        <ion-title>Menü</ion-title>-->
<!--      </ion-toolbar>-->
<!--    </ion-header>-->
<!--    <ion-content class="ion-padding">-->
<!--      <template v-slot:start>-->
<!--      </template>-->
<!--      <ion-list :inset="true">-->
<!--        <ion-item>-->
<!--          <ion-label @click="navigateTo('Home')">Startseite</ion-label>-->
<!--        </ion-item>-->
<!--        <ion-item>-->
<!--          <ion-label @click="navigateTo('RssPage')">RSS</ion-label>-->
<!--        </ion-item>-->
<!--        <ion-item>-->
<!--          <ion-label @click="navigateTo('ImpressumPage')">Impressum</ion-label>-->
<!--        </ion-item>-->
<!--        <ion-item>-->
<!--          <ion-label @click="navigateTo('DatenschutzPage')">Datenschutz</ion-label>-->
<!--        </ion-item>-->
<!--      </ion-list>-->
<!--    </ion-content>-->
<!--  </ion-menu>-->

<!--  <ion-page id="main-content">-->
<!--    <AppHeader :resetChat="resetChat" />-->

<!--    <ion-content>-->

<!--    </ion-content>    <AppFooter />-->
<!--  </ion-page>-->
<!--</template>-->




<script>
import axios from 'axios';
// import { IonHeader, IonMenu, IonTitle, IonToolbar, IonContent, IonPage, IonList, IonItem, IonLabel } from '@ionic/vue';
// import AppHeader from "@/components/page/Header.vue";
// import AppFooter from "@/components/page/Footer.vue";


export default {
  name: 'RssPage',
  components: {
    // IonLabel, IonList, IonItem,
    // IonButton, IonButtons,
    // AppHeader,
    // AppFooter,
    // IonHeader,
    // IonMenu,
    // IonTitle,
    // IonToolbar,
    // IonContent,
    // IonPage
  },
  data() {
    return {
      rssItems: [],
    };
  },
  created() {
    this.fetchRssFeed();
  },
  methods: {
    async fetchRssFeed() {
      try {
        const response = await axios.get('https://umwelt.thueringen.de/aktuelles/rss', {
          responseType: 'text',
        });
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response.data, 'application/xml');
        const items = xmlDoc.querySelectorAll('item');
        this.rssItems = Array.from(items).map(item => ({
          title: item.querySelector('title').textContent,
          description: item.querySelector('description').textContent,
          link: item.querySelector('link').textContent,
        }));
      } catch (error) {
        console.error('Error fetching RSS feed:', error);
      }
    },
    navigateTo(page) {
      this.$router.push({ name: page });
    },
  },
};
</script>

<style scoped>
ion-page {
  height: 100%;
}

ion-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.slider-image {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.slider-container {
  max-width: 1140px;
  width: 100%;
  margin: 0 auto;
}
</style>
<script setup lang="ts">
</script>